import { FPS_THRESHOLD, FPS_CHECK_INTERVAL_MS, FPS_STABILITY_DELAY_MS } from '../engine.constants';

export class FPSMonitor {
  private lastTime = performance.now();
  private frameCount = 0;
  private timeSinceStart = 0;

  currentFPS = 60;
  isFallbackActive = false;

  /** Starts a fresh measuring window, so time spent idle doesn't count as slow frames. */
  resume(now: number): void {
    this.lastTime = now;
    this.frameCount = 0;
  }

  tick(now: number, deltaMs: number): void {
    this.timeSinceStart += deltaMs;
    this.frameCount++;

    if (now >= this.lastTime + FPS_CHECK_INTERVAL_MS) {
      this.currentFPS = this.frameCount / ((now - this.lastTime) / 1000);
      this.lastTime = now;
      this.frameCount = 0;

      if (
        this.timeSinceStart > FPS_STABILITY_DELAY_MS &&
        !this.isFallbackActive &&
        this.currentFPS < FPS_THRESHOLD
      ) {
        this.isFallbackActive = true;
      }
    }
  }
}
